export default {
  /**
   * @description 更新标题
   * @param {String} title 标题
   */
  title: (titleText) => {
    const processTitle = process.env.VUE_APP_TITLE
    window.document.title = `${processTitle}${titleText ? ` — ${titleText}` : ''}`
  },

  /**
   * @description 打开新页面
   * @param {String} url 地址
   */
  open: (url) => {
    var a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.setAttribute('id', 'd2admin-link-temp')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(document.getElementById('d2admin-link-temp'))
  },

  /**
   * 字符串替换
   * @param {字符串} text 
   * @param {开始位置} before 
   * @param {替换长度} len 
   * @param {替换内容} char 
   */
  replaceText: (text, before = 1, len = 4, char = "*") => {
    if (!text) {
      return text
    }
    let t = text.substring(0, before) + char.padEnd(len, char) + text.substring(before + len)
    return t
  },
  /**
   * @description 格式化Bool
   * @param {bool} true/false
   */
  formatBool: (cellValue) => {
    return cellValue
      ? "<i class='el-icon-check' style='color:#67C23A'/>"
      : "<i class='el-icon-close' style='color:#909399'/>"
  },

  /**
   * @description 时间格式化
   * @param {*} time
   * @param {'{y}-{m}-{d} {h}:{i}:{s}'} cFormat
   */
  parseTime: (time, format = '{y}-{m}-{d}') => {
    if (!time) { return null }
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time)
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay(),
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      return value.toString().padStart(2, '0')
    })
    return time_str
  },

  /**
   * @description 时间格式化
   * @param {*} time
   * @param {*} option
   */
  formatTime: (time, option) => {
    if (('' + time).length === 10) {
      time = parseInt(time) * 1000
    } else {
      time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
      return '刚刚'
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
      return '1天前'
    }
    if (option) {
      return this.parseTime(time, option)
    } else {
      return (
        d.getMonth() +
        1 +
        '月' +
        d.getDate() +
        '日' +
        d.getHours() +
        '时' +
        d.getMinutes() +
        '分'
      )
    }
  },

  /**
   * @description 时间相减
   * @param {startTime} 开始时间
   * @param {endTime} 结束时间
   * @param {diffType}  秒second 分minute 小时hour day 天
   */
  diffDate: (startTime, endTime, diffType) => {
    //将计算间隔类性字符转换为小写
    diffType = diffType.toLowerCase()
    var sTime = new Date(startTime)      //开始时间
    var eTime = new Date(endTime)  //结束时间
    //作为除数的数字
    var divNum = 1
    switch (diffType) {
      case "second":
        divNum = 1000
        break
      case "minute":
        divNum = 1000 * 60
        break
      case "hour":
        divNum = 1000 * 3600
        break
      case "day":
        divNum = 1000 * 3600 * 24
        break
      default:
        break
    }
    return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(divNum))
  },

  /**
   * @description 金额转大写
   * @param {float} 小写金额
   */
  formatCnmoney: (value) => {
    if (!value) {
      return
    }
    var Num = Number(value).toFixed(2)
    if (isNaN(Num)) {
      //验证输入的字符是否为数字
      alert('请检查小写金额是否正确')
      return
    }
    //---字符处理完毕，开始转换，转换采用前后两部分分别转换---//
    var part = String(Num).split('.')
    var newchar = ''
    //小数点前进行转化
    for (var i = part[0].length - 1; i >= 0; i--) {
      if (part[0].length > 10) {
        alert('位数过大，无法计算')
        return ''
      } //若数量超过拾亿单位，提示
      var tmpnewchar = ''
      var perchar = part[0].charAt(i)
      switch (perchar) {
        case '0':
          tmpnewchar = '零' + tmpnewchar
          break
        case '1':
          tmpnewchar = '壹' + tmpnewchar
          break
        case '2':
          tmpnewchar = '贰' + tmpnewchar
          break
        case '3':
          tmpnewchar = '叁' + tmpnewchar
          break
        case '4':
          tmpnewchar = '肆' + tmpnewchar
          break
        case '5':
          tmpnewchar = '伍' + tmpnewchar
          break
        case '6':
          tmpnewchar = '陆' + tmpnewchar
          break
        case '7':
          tmpnewchar = '柒' + tmpnewchar
          break
        case '8':
          tmpnewchar = '捌' + tmpnewchar
          break
        case '9':
          tmpnewchar = '玖' + tmpnewchar
          break
      }
      switch (part[0].length - i - 1) {
        case 0:
          tmpnewchar = tmpnewchar + '元'
          break
        case 1:
          if (perchar != 0) tmpnewchar = tmpnewchar + '拾'
          break
        case 2:
          if (perchar != 0) tmpnewchar = tmpnewchar + '佰'
          break
        case 3:
          if (perchar != 0) tmpnewchar = tmpnewchar + '仟'
          break
        case 4:
          tmpnewchar = tmpnewchar + '万'
          break
        case 5:
          if (perchar != 0) tmpnewchar = tmpnewchar + '拾'
          break
        case 6:
          if (perchar != 0) tmpnewchar = tmpnewchar + '佰'
          break
        case 7:
          if (perchar != 0) tmpnewchar = tmpnewchar + '仟'
          break
        case 8:
          tmpnewchar = tmpnewchar + '亿'
          break
        case 9:
          tmpnewchar = tmpnewchar + '拾'
          break
      }
      newchar = tmpnewchar + newchar
    }
    //小数点之后进行转化
    if (Num.indexOf('.') != -1) {
      if (part[1].length > 2) {
        alert('小数点之后只能保留两位,系统将自动截段')
        part[1] = part[1].substr(0, 2)
      }
      for (i = 0; i < part[1].length; i++) {
        tmpnewchar = ''
        perchar = part[1].charAt(i)
        switch (perchar) {
          case '0':
            tmpnewchar = '零' + tmpnewchar
            break
          case '1':
            tmpnewchar = '壹' + tmpnewchar
            break
          case '2':
            tmpnewchar = '贰' + tmpnewchar
            break
          case '3':
            tmpnewchar = '叁' + tmpnewchar
            break
          case '4':
            tmpnewchar = '肆' + tmpnewchar
            break
          case '5':
            tmpnewchar = '伍' + tmpnewchar
            break
          case '6':
            tmpnewchar = '陆' + tmpnewchar
            break
          case '7':
            tmpnewchar = '柒' + tmpnewchar
            break
          case '8':
            tmpnewchar = '捌' + tmpnewchar
            break
          case '9':
            tmpnewchar = '玖' + tmpnewchar
            break
        }
        if (i == 0) tmpnewchar = tmpnewchar + '角'
        if (i == 1) tmpnewchar = tmpnewchar + '分'
        newchar = newchar + tmpnewchar
      }
    }
    //替换所有无用汉字
    while (newchar.search('零零') != -1) {
      newchar = newchar.replace('零零', '零')
    }
    newchar = newchar.replace('零亿', '亿')
    newchar = newchar.replace('亿万', '亿')
    newchar = newchar.replace('零万', '万')
    newchar = newchar.replace('零元', '元')
    newchar = newchar.replace('零角', '')
    newchar = newchar.replace('零分', '')

    if (
      newchar.charAt(newchar.length - 1) == '元' ||
      newchar.charAt(newchar.length - 1) == '角'
    ) {
      newchar = newchar + '整'
    }
    return newchar
  },

  /**
   * 树形结构扁平化
   * @param {*} data
   * @param {*} key
   */
  flatJson (data, key) {
    let res = []
    data.forEach((row) => {
      res.push(row)
      if (row[key]) {
        res = res.concat(this.flatJson(row[key], key))
      }
    })
    return res
  },

  /***
   * 数据分组
   * @param {arr} 数据源
   * @param {key} 分组字段
   */
  DataGroup (arr, key) {
    let newArr = [],
      types = {}
    arr.forEach(cur => {
      if (!(cur[key] in types)) {
        types[cur[key]] = { type: cur[key], items: [] }
        newArr.push(types[cur[key]])
      }
      types[cur[key]].items.push(cur)
    })
    return newArr
  }
}
